export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/eazytravels6?igsh=MW51cDFlczFhYnRmaQ==",
  facebook: "https://www.facebook.com/profile.php?id=61556813750562",
  tiktok: "https://www.tiktok.com/@eazytravels6?_r=1&_t=ZN-983sr6IYoiM",
  whatsapp: "https://wa.me/message/DF3VNE5BBTW5C1",
};

export const WHATSAPP_GREETING = "Hi! I'd like to know more about Eazy-Travels' visa and relocation services.";

export function whatsappChatUrl(message = WHATSAPP_GREETING) {
  const separator = SOCIAL_LINKS.whatsapp.includes("?") ? "&" : "?";
  return `${SOCIAL_LINKS.whatsapp}${separator}text=${encodeURIComponent(message)}`;
}
